"use client";

import { useFormControl } from "../__chunks/KKXTCJYN.js";
import { useFormContext } from "../__chunks/PQKUBRVU.js";
import "../__chunks/SZHY72KI.js";
import "../__chunks/G4PVPWEW.js";
import { useFocusable } from "../__chunks/Z4WWVOIF.js";
import "../__chunks/SWN3JYXT.js";
import { createElement, createHook, forwardRef, memo } from "../__chunks/7FZLUSKW.js";
import { useEvent } from "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadProps, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/form/form-input.tsx
import { invariant } from "@ariakit/core/utils/misc";
var TagName = "input";
var useFormInput = createHook(function useFormInput2(_a) {
  var _b = _a,
    store = _b.store,
    nameProp = _b.name,
    props = __objRest(_b, ["store", "name"]);
  var context = useFormContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "FormInput must be wrapped in a Form component.");
  var name = "".concat(nameProp);
  var onChangeProp = props.onChange;
  var onChange = useEvent(function (event) {
    onChangeProp == null ? void 0 : onChangeProp(event);
    if (event.defaultPrevented) return;
    store == null ? void 0 : store.setValue(name, event.target.value);
  });
  var value = store.useValue(name);
  props = __spreadProps(__spreadValues({
    value: value
  }, props), {
    onChange: onChange
  });
  props = useFocusable(props);
  props = useFormControl(__spreadValues({
    store: store,
    name: name
  }, props));
  return props;
});
var FormInput = memo(forwardRef(function FormInput2(props) {
  var htmlProps = useFormInput(props);
  return createElement(TagName, htmlProps);
}));
export { FormInput, useFormInput };